import type { ExamId, Workflow } from '@parsys/frontend_library';

// Find an exam property from the workflow exams by exam ID (without version)
export const getExamPropertyFromWorkflow = ({ examId, workflow, targetedProperty } : { examId: ExamId, workflow: Workflow, targetedProperty: string }) => {
  const allExams = Object.values(workflow?.transitions || {}).flatMap(t => t.exams_full || []);
  const exam = allExams.find(e => e.id === examId);
  if (!exam) {
    return null;
  }

  if (targetedProperty === 'label') {
    const name = exam.shortName || exam.name;
    if (typeof name === 'object') {
      return name.en || name.fr || Object.values(name)[0] || null;
    }
    return name || null;
  }

  return exam?.[targetedProperty] ?? null;
};
